import { render } from "./IconSettings.vue?vue&type=template&id=3c9afe5c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c9afe5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c9afe5c', __exports__)) {
    api.reload('3c9afe5c', __exports__)
  }
  
  module.hot.accept("./IconSettings.vue?vue&type=template&id=3c9afe5c", () => {
    api.rerender('3c9afe5c', render)
  })

}


export default __exports__